import { Component } from '@angular/core';
import { ShowupDirective } from '../../../directives/animations/showup.directive';

@Component({
  selector: 'section[app-about-manifesto-section]',
  imports: [ShowupDirective],
  templateUrl: './about-manifesto-section.html',
  styleUrl: './about-manifesto-section.scss',
})
export class AboutManifestoSection {
}
